import { apiClient } from './apiClient';

export type AssignmentType = {
  id: number;
  name: string;
};

export const getAssignmentTypes = (): Promise<AssignmentType[]> =>
  apiClient.get('/assignment-types', {});
